import React from "react"
import { Component } from "react";
import { Link } from "react-router-dom";

import TarjetasHtml from "../TarjetasHtml"
import Header from "../../Header";

import Login from "../../../img/Frontend/02-JavaScript/Persona-login.png";
import BYN from "../../../img/Frontend/02-JavaScript/BYN.png";

import "../../../styles/frontend/Tarjetas.css"
import "../../../styles/frontend/Funcionalidad.css"

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import Cookies from "universal-cookie"
import PropTypes from "prop-types"
import {setLanguage, translate} from 'react-switch-lang';


const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1365 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1365, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };

  const Dialog = "https://cdn-icons-png.flaticon.com/512/3608/3608186.png";
  const Cronometro = "https://cdn-icons-png.flaticon.com/512/1012/1012321.png";
  const Developer = "https://cdn-icons-png.flaticon.com/512/1688/1688400.png";


class Funcionalidad extends Component{

    constructor(props){
        super(props);
        const cookieLanguage = new Cookies('language');
        const lang = cookieLanguage.get('language');
        setLanguage(lang);
        
    }

    render(){
        const {t} = this.props;
    
        return (
            <div className="divCarrouselContainer">
                
                <Header urlBack="/My-Portfolio/frontend" showIcons={true}/>

                <Carousel responsive={responsive} containerClass="carouselFuncionalidad">

                    <TarjetasHtml link="https://4nr3.github.io/Dialog-boxes/" imagen={Dialog} alter="Dialgo box" titulo={t('js.box')}/>
                    <TarjetasHtml link="https://4nr3.github.io/Watch/" imagen= {Cronometro} alter="Reloj" titulo={t('js.crono')}/>
                    <TarjetasHtml link="https://4nr3.github.io/Toggle-theme/" imagen={BYN} alter="Cambiar tema" titulo={t('js.tema')}/>
                    <TarjetasHtml link="https://4nr3.github.io/Developer-profile/" imagen={Developer} alter="Perfil Developer" titulo={t('js.developer')}> <div>Hola</div></TarjetasHtml>
                </Carousel>

            </div>
    );
    }
}


export default translate(Funcionalidad);